import React from "react";
import PropTypes from "prop-types";
//import useImage from "use-image";
import { Image as ImageComponent } from 'react-konva';
import Konva from 'konva';
import { modifyBrightness, modifyContrast } from "../../../helpers/photo";
import { Profiler } from 'react';

Konva.Filters.IsolateTeeth2 = (imageData) =>  {
        //const { toothMask } = this.props;
        //console.log('call isolate teeth', toothMask)
        //if (toothMask) {
            let data = imageData.data;
            let idx = 0;
            for (let i = 0; i < data.length; i += 4) {
                let r = data[i];
                let g = data[i+1];
                let b = data[i+2];
                //let m = toothMask[idx];
                let gr = 0.114*b + 0.587*g + 0.299*r;
                data[i] = gr;//(gr*(255-m) + m*r)/255;
                data[i+1] = gr;//(gr*(255-m) + m*g)/255;
                data[i+2] = gr;//(gr*(255-m) + m*b)/255;
                idx++;
            }
        //}
    };
export default class Image extends React.PureComponent {
    
    tid = null;

    

    componentDidUpdate = (prevProps) => {
        let {image} = this.props;
        if (image) {
            let changed = true;//image != prevProps.image || brightness != prevProps.brightness || contrast != prevProps.contrast;
            
            if (this.imageRef && changed) {
                //console.log('image update')
                if (this.imageRef.isCached()) {
                    this.clearCanvases();
                    this.imageRef.clearCache();
                }
                
                //this.imageRef.getCanvas().getContext().drawImage(image, 0, 0)
                this.imageRef.cache();
                this.imageRef.getLayer().batchDraw();
            }
        }
    }

    componentDidMount = () => {
        let {image} = this.props;
        //console.log('image mount')
        if (image) {
            if (this.imageRef) {
                //console.log('image mount draw')
                /*const c = this.imageRef.getCanvas();
                c.width = image.width;
                c.height = image.height;
                c.getContext().drawImage(image, 0, 0)*/
                this.imageRef.cache();
                this.imageRef.getLayer().batchDraw();
            }
        }
    }

    componentWillUnmount() {
        if (this.imageRef) {
            //console.log('image unmount')
            this.clearCanvases();
            this.imageRef.clearCache();
            
            this.imageRef.destroy();
        }
        
    }

    clearCanvases = () => {
        //const cn = this.imageRef?.getCanvas()
        //if (cn) {
        //    cn.width = 0;
        //    cn.height = 0;
            //cn = null
        //}
        const cnv = this.imageRef?._cache?.get("canvas");
        if (cnv) {
            if (cnv.scene?._canvas) {
                cnv.scene._canvas.width = 0;
                cnv.scene._canvas.height = 0;
            }
            if (cnv.hit?._canvas) {
                cnv.hit._canvas.width = 0;
                cnv.hit._canvas.height = 0;
            }
            if (cnv.filter?._canvas) {
                cnv.filter._canvas.width = 0;
                cnv.filter._canvas.height = 0;
            }
        }
    }

    IsolateTeeth = (imageData) => {
        const { toothMask } = this.props;
        //console.log('call isolate teeth', toothMask)
        if (toothMask) {
            const data = imageData.data;
            let idx = 0;
            for (const i = 0; i < data.length; i += 4) {
                let r = data[i];
                let g = data[i+1];
                let b = data[i+2];
                let m = toothMask[idx];
                let gr = 0.114*b + 0.587*g + 0.299*r;
                data[i] = (gr*(255-m) + m*r)/255;
                data[i+1] = (gr*(255-m) + m*g)/255;
                data[i+2] = (gr*(255-m) + m*b)/255;
                idx++;
            }
        }
    };

    IsolateTeeth2 = (imageData) => {
        const { toothMask, toothMaskWidth, toothMaskHeight, toothMaskX, toothMaskY } = this.props;
        
        if (toothMask) {
            let data = imageData.data;
            let idx = 0;
            let scale = toothMaskWidth / imageData.width;
            let scaleY = toothMaskHeight / imageData.height;
            //let scale = Math.sqrt(toothMask.length / (data.length/4));
            //let maskWidth = Math.ceil(imageData.width*scale);
            let rowLen = imageData.width * 4;
            let x = toothMaskX;
            let y = toothMaskY;
            //let height = imageData.height;
            //console.log(data.length, toothMask.length, scale, scaleY, rowLen, toothMaskWidth, imageData.width, imageData.height);
            for (let i = 0; i < data.length; i += 4) {
                if (x >= rowLen) {
                    x = toothMaskX;
                    y++;
                    idx = toothMaskWidth * Math.round(y * scaleY);

                }
                let r = data[i];
                let g = data[i+1];
                let b = data[i+2];
                /*let yData = parseInt(i / rowLen);
                let y = Math.round(scale*yData);
                let x = Math.round(scale* (i - (yData * rowLen)) / 4);
                let m = toothMask[parseInt(y * maskWidth + x)];*/
                let m = toothMask[Math.round(idx)];
                
                if (m < 255) {
                    let gr = 0.114*b + 0.587*g + 0.299*r;
                    data[i] = (gr*(255-m) + m*r)/255;
                    data[i+1] = (gr*(255-m) + m*g)/255;
                    data[i+2] = (gr*(255-m) + m*b)/255;
                }
                
                idx += scale;
                x += 4;
            }
            //console.log('called isolate teeth', toothMask)
        }
    };

    render() {
        let {image, x, y, width, height, brightness, contrast, isGrayScale, draggable, rotation, scaleX, scaleY, dragBoundFunc, onDragMove, onDragEnd, onTransform, onTransformEnd, toothMask} = this.props;

        /*if (isNaN(width) || !image) {
            // TODO draw a loader here
            return <Text text={'Loading image...'} fontSize={20} fill={'#ffffff'}/>;
        }*/
        
        
    
        // available filters https://konvajs.org/api/Konva.Filters.htm
        let filters = [
            this.IsolateTeeth2,
            Konva.Filters.Brighten,
            Konva.Filters.Contrast,  
        ];
        
        if (isGrayScale) {
            filters.push(Konva.Filters.Grayscale);
        }

        //console.log('image render tooth mask', toothMask);
    
        return (image && !isNaN(x) && !isNaN(y) && !isNaN(width) && !isNaN(height)) ? 
            <ImageComponent
                ref={node => {
                    this.imageRef = node;
                }}
                x={x + width/2}
                y={y + height/2}
                image={image}
                width={width}
                filters={filters}
                brightness={modifyBrightness(brightness)}
                contrast={modifyContrast(contrast)}
                height={height}
                draggable={draggable}
                rotation={rotation}
                offset={{x : width/2, y : height/2}}
                scaleX={scaleX}
                scaleY={scaleY}
                dragBoundFunc={dragBoundFunc}
                onDragMove={onDragMove}
                onDragEnd={onDragEnd}
                onTransform={onTransform}
                onTransformEnd={onTransformEnd}
                //imgMask={toothMask}
            />
            : null;
        ;
    }
}

Image.propTypes = {
    image: PropTypes.object,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
};
